export const UPDATE_DISPLAY_ADS = 'UPDATE_DISPLAY_ADS';

export const updateDisplayAds = (payload) => ({
    type: UPDATE_DISPLAY_ADS,
    payload,
});

export default (state = {}, action) =>
    action.type === UPDATE_DISPLAY_ADS ? { ...state, ...action.payload } : state;
